<div style="width: fit-content; height: 900px; max-width: 90vw; max-height: 90vh;" data-cy="document-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%; width: 100%; overflow: hidden;">
    <div class="section-header" style="flex-basis: 30px; min-height: 30px;" data-cy="document-header-section">
      <div class="section-header-title" data-cy="document-title-text">
        Document View
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; max-height: 100%; max-width: 100%; overflow: hidden; background-color: black;" data-cy="document-content-section">
      <img style="object-fit: contain; width: 100%; height: 100%;" [src]="data" data-cy="document-image-display" />
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 40px; min-height: 40px;" data-cy="document-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="document-ok-button">Ok</button>
    </div>
  </div>
</div>
